import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import { postTradeProposalBundleAddToPrimary } from "../request/postTradeProposalBundleAddToPrimary";
import { keyMaker as singleProposalsKeyMaker } from "./useGetProposal";
import { TradeProposalId } from "./useGetProposals";
import { keyMaker as allProposalsKeyMaker } from "./useGetProposals";
import { keyMaker as singleBundleKeyMaker } from "./useGetTradeProposalBundle";
import { keyMaker as allBundlesKeyMaker, TradeProposalBundleId, } from "./useGetTradeProposalBundles";
export { TradeProposalId, TradeProposalBundleId };
const useAddTradeProposalToPrimaryBundle = (config) => {
    const queryClient = useQueryClient();
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey("TradeProposalBundle:AddToPrimaryBundle"));
    const mutation = useMutation({
        mutationFn: async (info) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return postTradeProposalBundleAddToPrimary(info.tradeProposalIds, info.type, idempotencyKey, config);
        },
        onSettled: () => {
            setIdempotencyKey(genIdempotencyKey("TradeProposalBundle:AddToPrimaryBundle"));
        },
        onSuccess: async (response, { tradeProposalIds: input }) => {
            // Bundles
            await queryClient.invalidateQueries({
                queryKey: allBundlesKeyMaker(null),
            });
            await queryClient.invalidateQueries({
                queryKey: singleBundleKeyMaker(response),
            });
            // Proposals
            await queryClient.invalidateQueries({
                queryKey: allProposalsKeyMaker(null),
            });
            await Promise.allSettled(input.map(async (id) => queryClient.invalidateQueries({
                queryKey: singleProposalsKeyMaker(id),
            })));
            // invalidate all details
            await queryClient.invalidateQueries({
                queryKey: singleProposalsKeyMaker(null),
            });
        },
    });
    return mutation.mutateAsync;
};
export default useAddTradeProposalToPrimaryBundle;
//# sourceMappingURL=useAddTradeProposalToPrimaryBundle.js.map